import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, StatusPill } from "@/components/common";
import { Download } from "lucide-react";
import DataList from "@/components/DataList";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const STATUS_OPTIONS = [
  { value: "all", label: "ALL" },
  { value: "draft", label: "DRAFT" },
  { value: "open", label: "OPEN" },
  { value: "matched", label: "MATCHED" },
  { value: "quoted", label: "QUOTED" },
  { value: "awarded", label: "AWARDED" },
  { value: "expired", label: "EXPIRED" },
];

const URGENCY_OPTIONS = [
  { value: "all", label: "ALL" },
  { value: "critical", label: "CRITICAL" },
  { value: "high", label: "HIGH" },
  { value: "normal", label: "NORMAL" },
];

export default function RfqList() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/rfqs").then(r => setRows(r.data)); }, []);

  const columns = [
    { key: "code", label: "Code",
      render: r => <span className="font-mono" style={{ color: "var(--amber-400)" }}>{r.code}</span>,
      search: r => r.code },
    { key: "product_name", label: "Product",
      render: r => r.product_name, search: r => r.product_name },
    { key: "category", label: "Category",
      render: r => <span style={{ color: "var(--ink-dim)", fontSize: 13 }}>{r.category}</span>,
      search: r => r.category },
    { key: "quantity", label: "Qty", render: r => `${r.quantity} ${r.unit}` },
    { key: "urgency", label: "Urgency",
      render: r => <span className="pill" style={{ color: r.urgency === "critical" ? "var(--red)" : r.urgency === "high" ? "var(--amber-400)" : "var(--ink-dim)", borderColor: "var(--line)" }}>{r.urgency}</span> },
    { key: "status", label: "Status", render: r => <StatusPill status={r.status} /> },
    { key: "created_at", label: "Created",
      render: r => <span className="font-mono" style={{ color: "var(--ink-mute)", fontSize: 12 }}>{new Date(r.created_at).toLocaleDateString()}</span> },
    { key: "actions", label: "",
      render: r => <Link to={`/app/rfqs/${r.id}`} data-testid={`rfq-list-open-${r.code}`} className="btn btn-ghost" style={{ padding: "6px 12px", fontSize: 12 }}>Open</Link> },
  ];

  const filters = [
    { key: "status", label: "Status", options: STATUS_OPTIONS,
      match: (row, value) => value === "all" || row.status === value },
    { key: "urgency", label: "Urgency", options: URGENCY_OPTIONS,
      match: (row, value) => value === "all" || row.urgency === value },
  ];

  return (
    <>
      <PageHeader title="My RFQs" subtitle="All sourcing requests you've issued." actions={
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <a href={`${BACKEND_URL}/api/export/rfqs.csv`} target="_blank" rel="noreferrer" className="btn btn-ghost"><Download size={14} /> Export</a>
          <Link to="/app/rfqs/new" className="btn btn-primary" data-testid="new-rfq-btn">+ New RFQ</Link>
        </div>
      } />
      <DataList
        testId="rfq-list"
        rows={rows}
        columns={columns}
        filters={filters}
        emptyText="No RFQs yet — tap “+ New RFQ” to get started."
        searchPlaceholder="Search by code, product, or category…"
      />
    </>
  );
}
